import keyMirror from 'keymirror';

export const ActionTypes = keyMirror({
  SET_SELECTED_COMPANY: null
});

export interface ISelectedCompaniesState {
  selectedCompany?: Company;
}